module.exports = __webpack_public_path__ + "static/media/29ADMSPC17.b9753f21.jpg";